import { handleActions } from 'redux-actions';

const defaultAuthState = {
  fetching: false,
  loggingOut: false,
  error: null,
  user: {},
  successMessage: null,
  isResetPasswordSuccess: false,
  freshTokenPromise: null,
  refreshStatus: false,
  builderUserList: [],
  adminSelectList: [],
  isConfirmEmailLoading: true,
  ImportData: [],
  externalUser:{},
  hobrand:[]
};

const authReducer = handleActions(
  {
    REQUEST_LOGIN_SUCCESS: (state, action) => {
      return {
        ...state,
        fetching: false,
        error: null,
        user: action.data.data
      };
    },
    GET_CURRENT_USER_SUCCESS: (state, action) => {
      return {
        ...state,
        user: action.data.data
      };
    },
    SET_HO_BRANDING_LOGO_COLOR_SUCCESS:(state, action) =>{
      return {
        ...state,
        hobrand: action.data.data
      };
    },
    REQUEST_LOGIN_ERROR: (state, action) => {
      return {
        error: action.data.error
      };
    },
    ACTIVE_USER_SUCCESS: (state, action) => {
      return {
        ...state,
        user: action.data.data
      };
    },
    ACTIVE_USER_FAILED: (state, action) => {
      return {
        ...state,
        error: action.data.error
      };
    },

    CONFIRM_EMAIL_SUCCESS: state => {
      return {
        ...state,
        isConfirmEmailLoading: false
      };
    },
    CONFIRM_EMAIL_FAILED: (state, action) => {
      return {
        ...state,
        error: action.data.error,
        isConfirmEmailLoading: false
      };
    },
    RESET_PASSWORD_SUCCESS: state => {
      return {
        ...state,
        isResetPasswordSuccess: true
      };
    },
    RESET_PASSWORD_FAILED: (state, action) => {
      return {
        ...state,
        error: action.data.error
      };
    },
    REFRESH_TOKEN_SUCCESS: (state, action) => {
      return {
        ...state,
        fetching: false,
        error: null,
        user: action.data.data,
        refreshStatus: true
      };
    },
    RESET_REFRESH_TOKEN: state => {
      return {
        ...state,
        refreshStatus: false
      };
    },
    REFRESHING_TOKEN: (state, action) => {
      return {
        ...state,
        freshTokenPromise: action.freshTokenPromise
      };
    },
    OAUTH_SSO_SUCCESS: (state, action) => {
      return {
        ...state,
        user: action.data
      };
    },
    SELECT_LIST_BUILDER_USER_SUCCESS: (state, action) => {
      return {
        ...state,
        builderUserList: action.data
      };
    },
    SELECT_LISTS_BUILDER_USER_SUCCESS: (state, action) => {
      return {
        ...state,
        builderUserList: action.data
      };
    },
    SELECT_LIST_ADMIN_SUPER_ADMIN_SUCCESS: (state, action) => {
      return {
        ...state,
        adminSelectList: action.data
      };
    },
    ADD_ITEM_TO_IMPORT_DATA: (state, action) => {
      return {
        ...state,
        ImportData: [...state.ImportData, action.data]
      };
    },
    // GET_EXTRANAL_USER_AUTH_TOKEN_SUCCESS: (state, action) => {
    //   return {
    //     ...state,
    //     externalUser:action.payload
    //   };
    // },
    REMOVE_ITEM_IN_IMPORT_DATA: (state, action) => {
      let newStateImportData = [...state.ImportData];
      newStateImportData = newStateImportData.filter(
        x => x.projectName !== action.data.projectName
      );

      return {
        ...state,
        ImportData: newStateImportData
      };
    }
  },
  defaultAuthState
);

export { authReducer };



// WEBPACK FOOTER //
// ./src/Auth/reducer.js